import React, { forwardRef } from 'react';
import { Icon } from 'ui';

type Props = {
  onClick?: () => void;
  size?: 'tiny' | 'small' | 'medium' | 'large' | 'huge';
};

const EllipsisButton = forwardRef(({ onClick, size }: Props, ref) => {
  const classArray = [
    'inline-flex',
    'cursor-pointer',
    'border',
    'border-transparent',
    'hover:border-gray-200',
    'hover:bg-white',
    'hover:shadow-sm',
    'transition-all',
    'text-sm',
  ];

  let roundingSize = '';

  switch (size) {
    case 'tiny':
      classArray.push('px-2.5', 'py-1.5', 'text-xs');
      break;
    case 'small':
      roundingSize = '-md';
      classArray.push('px-3', 'py-2.5', 'text-sm');
      break;
    default:
    case 'medium':
      roundingSize = '-md';
      classArray.push('px-4', 'py-2.5', 'text-sm');
      break;
    case 'large':
      roundingSize = '-md';
      classArray.push('px-4', 'py-2.5', 'text-base');
      break;
    case 'huge':
      roundingSize = '-md';
      classArray.push('px-6', 'py-3.5', 'text-base');
      break;
  }

  classArray.push(`rounded${roundingSize}`);

  return (
    <button ref={ref} type="button" className={classArray.join(' ')} onClick={onClick}>
      <Icon fitted name="dots-horizontal" className="w-4 text-gray-600 hover:text-gray-700" />
    </button>
  );
});

export default EllipsisButton;
